export const virtualScrollerProps = {
  appendOnly:         { type: Boolean,         default: false },
  autoSize:           { type: Boolean,         default: false },
  class:              null,
  columns:            { type: Array,           default: null },
  delay:              { type: Number,          default: 0 },
  disabled:           { type: Boolean,         default: false },
  id:                 { type: String,          default: null },
  inline:             { type: Boolean,         default: false },
  items:              { type: Array,           default: null },
  itemSize:           { type: [Number, Array], default: null },
  lazy:               { type: Boolean,         default: false },
  loaderDisabled:     { type: Boolean,         default: false },
  loading:            { type: Boolean,         default: false },
  numToleratedItems:  { type: Number,          default: null, },
  orientation:        { type: String,          default: 'vertical', },
  resizeDelay:        { type: Number,          default: 10 },
  scrollHeight:       null,
  scrollWidth:        null,
  showLoader:         { type: Boolean,         default: false },
  showSpacer:         { type: Boolean,         default: true },
  step:               { type: Number,          default: 0 },
  style:              null,
  tabindex:           { type: Number,          default: 0 },
};

